/**
 * Product Shipping Rates Calculator
 * Vanilla JavaScript implementation (converted from Alpine.js)
 */

class ShippingSimulator {
  constructor(container) {
    this.container = container;
    this.variantId = container.dataset.variantId;
    
    this.state = {
      shippingEnterprises: [],
      state: "",
      city: "",
      error: "",
      loading: false,
      buttonText: "Calcular"
    };

    this.states = {
      AC: "Acre",
      AL: "Alagoas",
      AP: "Amapá",
      AM: "Amazonas",
      BA: "Bahia",
      CE: "Ceará",
      DF: "Distrito Federal",
      ES: "Espírito Santo",
      GO: "Goiás",
      MA: "Maranhão",
      MT: "Mato Grosso",
      MS: "Mato Grosso do Sul",
      MG: "Minas Gerais",
      PA: "Pará",
      PB: "Paraíba",
      PR: "Paraná",
      PE: "Pernambuco",
      PI: "Piauí",
      RJ: "Rio de Janeiro",
      RN: "Rio Grande do Norte",
      RS: "Rio Grande do Sul",
      RO: "Rondônia",
      RR: "Roraima",
      SC: "Santa Catarina",
      SP: "São Paulo",
      SE: "Sergipe",
      TO: "Tocantins"
    };

    this.elements = {
      errorContainer: container.querySelector('.error-container'),
      errorMessage: container.querySelector('.error-message'),
      cepInput: container.querySelector('.cep-input'),
      calculateButton: container.querySelector('.calculate-button'),
      buttonText: container.querySelector('.button-text'),
      resultsContainer: container.querySelector('.results-container'),
      deliveryLocation: container.querySelector('.delivery-location'),
      loadingContainer: container.querySelector('.loading-container'),
      ratesListContainer: container.querySelector('.rates-list-container'),
      ratesList: container.querySelector('.rates-list')
    };

    this.init();
  }

  getQuantity() {
    // Captura o valor de 1 unidade definido no metafield (ex: 2.5)
    const rawStep = this.container.dataset.quantityStep;
    const step = rawStep ? parseFloat(rawStep.replace(',', '.')) : 1;
    const unitStep = !isNaN(step) && step > 0 ? step : 1;

    // Busca o input visual da PDP
    const qtyInput = document.querySelector('.quantity-selector__input_custom') 
                  || document.querySelector('.quantity-selector__input')
                  || document.querySelector('[name="quantity"]');

    if (qtyInput) {
      const rawValue = qtyInput.value.replace(',', '.');
      const userSelectedQty = parseFloat(rawValue);

      if (!isNaN(userSelectedQty) && userSelectedQty > 0) {
        // Converte o valor fracionado em unidades reais de estoque
        // Exemplo: 2,5 / 2,5 = 1 unidade real
        // Exemplo: 5,0 / 2,5 = 2 unidades reais
        const realQuantity = Math.round(userSelectedQty / unitStep);
        return realQuantity > 0 ? realQuantity : 1;
      }
    }

    return 1;
  }

  init() {
    this.applyMargins();
    this.setupEventListeners();
    this.maskCEP();
    this.setupCartObserver();
    
    if (window.location.search.includes('addToCart')) {
      this.addToCart();
    }
  }

  setupCartObserver() {
    const cartDrawer = document.getElementById('mini-cart');
    if (!cartDrawer) return;

    this.cartObserver = new MutationObserver((mutations) => {
      if (window.calculatingShipping) {
        mutations.forEach((mutation) => {
          if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
            if (cartDrawer.hasAttribute('open')) {
              cartDrawer.removeAttribute('open');
              cartDrawer.open = false;
            }
          }
        });
      }
    });

    this.cartObserver.observe(cartDrawer, {
      attributes: true,
      attributeFilter: ['open']
    });
  }

  applyMargins() {
    const marginTop = this.container.dataset.marginTop;
    const marginBottom = this.container.dataset.marginBottom;
    
    if (marginTop) {
      this.container.style.marginTop = `${marginTop}px`;
    }
    if (marginBottom) {
      this.container.style.marginBottom = `${marginBottom}px`;
    }
  }

  setupEventListeners() {
    this.elements.cepInput.addEventListener('input', () => this.validateCEP());
    this.elements.calculateButton.addEventListener('click', () => this.handleCalculate());
  }

  maskCEP() {
    this.elements.cepInput.addEventListener('input', (event) => {
      let valor = event.target.value;
      valor = valor.replace(/\D/g, '');
      valor = valor.replace(/^(\d{5})(\d)/, '$1-$2');
      event.target.value = valor;
    });
  }

  validateCEP() {
    const cep = this.elements.cepInput.value.replace(/\D/g, '');
    this.elements.calculateButton.disabled = cep.length !== 8;
  }

  async handleCalculate() {
    const cep = this.elements.cepInput.value;
    await this.shippingCalculate(cep);
  }

  lockCartDrawer() {
    if (!document.getElementById('shipping-calc-lock-style')) {
      const style = document.createElement('style');
      style.id = 'shipping-calc-lock-style';
      style.textContent = `
        body.shipping-calculating #mini-cart,
        body.shipping-calculating cart-drawer,
        body.shipping-calculating .drawer,
        body.shipping-calculating .mini-cart,
        body.shipping-calculating [id*="cart-drawer"],
        body.shipping-calculating [class*="cart-drawer"],
        body.shipping-calculating [class*="mini-cart"],
        body.shipping-calculating .drawer__overlay,
        body.shipping-calculating .ea-upsell-popups,
        body.shipping-calculating #ea-upsell-popups-root,
        body.shipping-calculating .ea-upsell-popups-backdrop,
        body.shipping-calculating .up-minicartdiv,
        body.shipping-calculating [class*="ea-upsell"],
        body.shipping-calculating [id*="ea-upsell"],
        body.shipping-calculating [class*="upsell"],
        body.shipping-calculating [class*="popup"],
        body.shipping-calculating [class*="modal"][style*="display: block"],
        body.shipping-calculating .ea-boost-upsell,
        body.shipping-calculating .easyapps-upsell {
          display: none !important;
          visibility: hidden !important;
          opacity: 0 !important;
          pointer-events: none !important;
          position: fixed !important;
          left: -9999px !important;
          top: -9999px !important;
          z-index: -9999 !important;
        }
      `;
      document.head.appendChild(style);
    }
    document.body.classList.add('shipping-calculating');
    
    this.blockEAUpsellEvents();
    
    if (window.jQuery && !window._originalJQueryAttr) {
      window._originalJQueryAttr = jQuery.fn.attr;
      jQuery.fn.attr = function(name, value) {
        if (window.calculatingShipping && name === 'open' && value === 'true') {
          const isCart = this.is('#mini-cart, cart-drawer, [class*="cart"], [class*="drawer"]');
          if (isCart) {
            return this;
          }
        }
        return window._originalJQueryAttr.apply(this, arguments);
      };
    }
  }

  blockEAUpsellEvents() {
    const eventNames = [
      'ea_upsell_show',
      'ea_upsell_open',
      'eaUpsellShow',
      'upsell:show',
      'upsell:open',
      'cart:upsell:show'
    ];
    
    if (!window._eaUpsellEventBlocker) {
      window._eaUpsellEventBlocker = (e) => {
        if (window.calculatingShipping) {
          e.stopImmediatePropagation();
          e.preventDefault();
          return false;
        }
      };
      
      eventNames.forEach(eventName => {
        document.addEventListener(eventName, window._eaUpsellEventBlocker, true);
        window.addEventListener(eventName, window._eaUpsellEventBlocker, true);
      });
    }
  }

  forceCloseCart() {
    const cartDrawer = document.getElementById('mini-cart');
    if (cartDrawer) {
      cartDrawer.removeAttribute('open');
      cartDrawer.open = false;
      cartDrawer.style.display = 'none';
      setTimeout(() => { cartDrawer.style.display = ''; }, 10);
    }
    
    document.querySelectorAll('cart-drawer, .drawer, [class*="cart-drawer"], [class*="mini-cart"]').forEach(el => {
      el.removeAttribute('open');
      if (el.open !== undefined) el.open = false;
    });
    
    const overlay = document.querySelector('.drawer__overlay');
    if (overlay) overlay.click();
  }

  hideEAUpsellPopups() {
    const selectors = [
      '.ea-upsell-popups',
      '#ea-upsell-popups-root',
      '.ea-upsell-popups-backdrop',
      '.up-minicartdiv',
      '[class*="ea-upsell"]',
      '[id*="ea-upsell"]',
      '[class*="upsell-popup"]',
      '[class*="ea-boost"]',
      '[class*="easyapps"]',
      '.ea-boost-upsell',
      '.easyapps-upsell',
      '[data-ea-upsell]',
      '[data-ea*="upsell"]'
    ];
    
    selectors.forEach(selector => {
      try {
        document.querySelectorAll(selector).forEach(el => {
          el.style.setProperty('display', 'none', 'important');
          el.style.setProperty('visibility', 'hidden', 'important');
          el.style.setProperty('opacity', '0', 'important');
          el.style.setProperty('pointer-events', 'none', 'important');
          el.style.setProperty('z-index', '-9999', 'important');
          el.style.setProperty('position', 'fixed', 'important');
          el.style.setProperty('left', '-9999px', 'important');
          el.style.setProperty('top', '-9999px', 'important');
        });
      } catch (e) {
        // Ignora erros de seletores inválidos
      }
    });
  }

  unlockCartDrawer() {
    document.body.classList.remove('shipping-calculating');
    this.forceCloseCart();
    setTimeout(() => this.forceCloseCart(), 100);
    setTimeout(() => this.forceCloseCart(), 300);
    setTimeout(() => this.forceCloseCart(), 500);
  }

  getCacheKey(cep) {
    const qty = this.getQuantity();
    return `shipping_cache_${this.variantId}_${qty}_${cep}`;
  }

  getCache(cep) {
    try {
      const cached = localStorage.getItem(this.getCacheKey(cep));
      if (cached) {
        const data = JSON.parse(cached);
        if (data.timestamp && Date.now() - data.timestamp < 30 * 60 * 1000) {
          return data;
        }
        localStorage.removeItem(this.getCacheKey(cep));
      }
    } catch (e) {}
    return null;
  }

  setCache(cep, cepData, rates) {
    try {
      localStorage.setItem(this.getCacheKey(cep), JSON.stringify({
        cepData,
        rates,
        timestamp: Date.now()
      }));
    } catch (e) {}
  }

  async shippingCalculate(cep) {
    this.state.error = "";
    this.hideError();
    this.setLoading(true);
    this.state.buttonText = "Calculando...";
    this.updateButtonText();

    cep = cep.replace(/-/g, '');

    if (cep.length === 8) {
      try {
        const cached = this.getCache(cep);
        if (cached) {
          this.state.state = this.states[cached.cepData.uf];
          this.state.city = cached.cepData.localidade;
          this.state.shippingEnterprises = cached.rates;
          this.setLoading(false);
          this.state.buttonText = "Calcular";
          this.updateButtonText();
          this.renderResults();
          return;
        }
        
        const cepData = await this.getCepData(cep);
        
        if (!cepData || cepData.erro || !cepData.uf) {
          this.state.error = "CEP inválido ou não encontrado.";
          this.showError();
          this.setLoading(false);
          this.state.buttonText = "Calcular";
          this.updateButtonText();
          return;
        }
        
        window.calculatingShipping = true;
        window.__shippingEstimatorContext = { active: true };
        this.lockCartDrawer();
        
        const cartCloserInterval = setInterval(() => {
          const cart = document.getElementById('mini-cart');
          if (cart) {
            cart.removeAttribute('open');
            cart.open = false;
            cart.style.setProperty('transform', 'translateX(100%)', 'important');
            cart.style.setProperty('visibility', 'hidden', 'important');
            cart.style.setProperty('opacity', '0', 'important');
            cart.style.setProperty('pointer-events', 'none', 'important');
            cart.style.setProperty('display', 'none', 'important');
          }
          document.querySelectorAll('.drawer[open], cart-drawer[open], [class*="drawer"][open], .drawer__overlay').forEach(el => {
            el.removeAttribute('open');
            if (el.open !== undefined) el.open = false;
            el.style.setProperty('display', 'none', 'important');
            el.style.setProperty('visibility', 'hidden', 'important');
          });
          this.hideEAUpsellPopups();
        }, 5);
        
        const [cartContent, currentCookie] = await Promise.all([
          this.getCartContent(),
          Promise.resolve(this.getCookie())
        ]);
        
        await this.removeFromCart();
        // this.updateCookie("fake_card_" + this.variantId);
        await this.addToCart();
        
        const { uf, localidade, cep: foo } = cepData;
        this.state.state = this.states[uf];
        this.state.city = localidade;
        await this.cartGetRates("Brazil", this.states[uf], localidade, foo);
        
        this.setCache(cep, cepData, this.state.shippingEnterprises);
        
        await this.removeFromCart();
        // this.updateCookie(currentCookie);
        await this.updateCartContent(cartContent);
        // DISPARE ESTES EVENTOS PARA ATUALIZAR O MINICART DA SHOPIFY:
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
        if (window.Shopify && Shopify.theme && Shopify.theme.cart) {
          // Garante sincronização em temas da Shopify
          fetch('/cart.js').then(res => res.json()).then(cart => {
            document.dispatchEvent(new CustomEvent('cart:build', { detail: cart }));
          });
        }
        
        clearInterval(cartCloserInterval);
        window.__shippingEstimatorContext = { active: false };
        window.calculatingShipping = false;
        this.unlockCartDrawer();
        
        const cart = document.getElementById('mini-cart');
        if (cart) {
          cart.style.removeProperty('transform');
          cart.style.removeProperty('visibility');
          cart.style.removeProperty('opacity');
          cart.style.removeProperty('pointer-events');
          cart.style.removeProperty('display');
        }
        document.querySelectorAll('.drawer, cart-drawer, [class*="drawer"], .drawer__overlay').forEach(el => {
          el.style.removeProperty('display');
          el.style.removeProperty('visibility');
        });
        
        this.setLoading(false);
        this.state.buttonText = "Calcular";
        this.updateButtonText();
        this.renderResults();
      } catch (error) {
        console.error("Error:", error);
        this.state.error = "Erro ao calcular o frete. Tente novamente.";
        this.showError();
        clearInterval(cartCloserInterval);
        window.__shippingEstimatorContext = { active: false };
        window.calculatingShipping = false;
        this.unlockCartDrawer();
        
        const cart = document.getElementById('mini-cart');
        if (cart) {
          cart.style.removeProperty('transform');
          cart.style.removeProperty('visibility');
          cart.style.removeProperty('opacity');
          cart.style.removeProperty('pointer-events');
          cart.style.removeProperty('display');
        }
        document.querySelectorAll('.drawer, cart-drawer, [class*="drawer"], .drawer__overlay').forEach(el => {
          el.style.removeProperty('display');
          el.style.removeProperty('visibility');
        });
        this.setLoading(false);
        this.state.buttonText = "Calcular";
        this.updateButtonText();
      }
    } else {
      this.state.error = "CEP inválido ou não encontrado.";
      this.showError();
      this.setLoading(false);
      this.state.buttonText = "Calcular";
      this.updateButtonText();
    }
  }

  async getCartContent() {
    try {
      const response = await fetch("/cart.js", {
        headers: {
          "X-Shipping-Estimator": "1"
        }
      });
      const data = await response.json();
      return data.items;
    } catch (error) {
      this.state.error = error;
      console.error("Error:", error);
      return [];
    }
  }

  async updateCartContent(cartContent) {
    // Transforma a lista de itens originais em um objeto de quantidades por variant_id
    const updates = {};
    if (Array.isArray(cartContent)) {
      cartContent.forEach(item => {
        updates[item.variant_id || item.id] = item.quantity;
      });
    }

    try {
      const response = await fetch("/cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Shipping-Estimator": "1"
        },
        body: JSON.stringify({ updates }),
      });
      return await response.json();
    } catch (error) {
      this.state.error = error;
      console.error("Error updating cart:", error);
    }
  }

  async cartGetRates(country, state, city, zip) {
    try {
      const response = await fetch("/cart/shipping_rates.json?" + new URLSearchParams({
        "shipping_address[country]": country,
        "shipping_address[province]": state,
        "shipping_address[zip]": zip
      }).toString());
      const data = await response.json();
      this.state.shippingEnterprises = data;
    } catch (error) {
      this.state.error = error;
      console.error("Error:", error);
    }
  }

  async getCepData(cep) {
    const response = await fetch("https://viacep.com.br/ws/" + cep + "/json/");
    const data = await response.json();
    return data;
  }

  getCookie() {
    let name = "cart=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  updateCookie(cvalue) {
    const d = new Date();
    d.setTime(d.getTime() + 14 * 86400000);
    let expires = " expires=" + d.toUTCString();
    const cookie = "cart=" + cvalue + expires + " path=/";
    document.cookie = cookie;
    return cookie;
  }

  async addToCart() {
    const quantity = this.getQuantity();

    let formData = {
      "items": [{
        "id": parseInt(this.variantId),
        "quantity": quantity
      }]
    };
    
    try {
      const response = await fetch("/cart/add.js", {
        method: "POST",
        body: JSON.stringify(formData),
        headers: {
          "Content-Type": "application/json",
          "X-Shipping-Estimator": "1"
        },
      });
      return await response.json();
    } catch (error) {
      this.state.error = error;
      console.error("Error:", error);
    }
  }

  async removeFromCart() {
    try {
      const response = await fetch("/cart/clear.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Shipping-Estimator": "1"
        },
      });
      return await response.json();
    } catch (error) {
      this.state.error = error;
      console.error("Error:", error);
    }
  }

  pageReload() {
    this.state.city = "";
    this.state.shippingEnterprises = [];
    this.elements.resultsContainer.style.display = 'none';
  }

  setLoading(loading) {
    this.state.loading = loading;
    
    if (loading) {
      this.elements.loadingContainer.style.display = 'flex';
      this.elements.loadingContainer.classList.add('show');
      this.elements.loadingContainer.classList.remove('hide');
      this.elements.ratesListContainer.style.display = 'none';
    } else {
      this.elements.loadingContainer.classList.add('hide');
      this.elements.loadingContainer.classList.remove('show');
      setTimeout(() => {
        this.elements.loadingContainer.style.display = 'none';
      }, 700);
    }
  }

  updateButtonText() {
    this.elements.buttonText.textContent = this.state.buttonText;
  }

  showError() {
    this.elements.errorMessage.textContent = this.state.error;
    this.elements.errorContainer.style.display = 'block';
  }

  hideError() {
    this.elements.errorContainer.style.display = 'none';
    this.elements.errorMessage.textContent = '';
  }

  renderResults() {
    if (this.state.city && !this.state.error) {
      this.elements.deliveryLocation.textContent = `Opções de entrega para ${this.state.city} - ${this.state.state}`;
      this.elements.resultsContainer.style.display = 'flex';
      this.elements.resultsContainer.classList.add('show');
      this.elements.resultsContainer.classList.remove('hide');
      
      this.renderRates();
    }
  }

  renderRates() {
    if (!this.state.loading && this.state.shippingEnterprises.shipping_rates) {
      this.elements.ratesListContainer.style.display = 'block';
      this.elements.ratesListContainer.classList.add('show');
      this.elements.ratesListContainer.classList.remove('hide');
      
      this.elements.ratesList.innerHTML = '';
      
      this.state.shippingEnterprises.shipping_rates.forEach((enterprise, index) => {
        const rateItem = this.createRateItem(enterprise);
        this.elements.ratesList.appendChild(rateItem);
        
        setTimeout(() => {
          rateItem.classList.add('show');
        }, 100 * index);
      });
    }
  }

  createRateItem(enterprise) {
    const div = document.createElement('div');
    div.className = 'rate-item';

    const nameSpan = document.createElement('span');
    nameSpan.className = 'rate-name';
    nameSpan.textContent = enterprise.name;
    div.appendChild(nameSpan);

    const bottomRow = document.createElement('div');
    bottomRow.className = 'rate-bottom-row';

    if (enterprise.delivery_days && enterprise.delivery_days.length !== 0) {
      const deliverySpan = document.createElement('span');
      deliverySpan.className = 'rate-delivery';
      deliverySpan.textContent = ` | ${enterprise.delivery_days[1]} dias úteis`;
      bottomRow.appendChild(deliverySpan);
    }

    const priceSpan = document.createElement('span');
    priceSpan.className = 'rate-price';
    if (enterprise.price == '0.00') {
      priceSpan.textContent = 'Frete Grátis';
    } else {
      priceSpan.textContent = `R$ ${enterprise.price.replace('.', ',')}`;
    }
    bottomRow.appendChild(priceSpan);

    div.appendChild(bottomRow);

    return div;
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const simulatorContainer = document.getElementById('simulator-shipping');
  if (simulatorContainer) {
    new ShippingSimulator(simulatorContainer);
  }
});
